export default "__VITE_ASSET__18ceade8__"